import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ActivationComponent } from '../activation/activation.component';
import { ResetPasswordComponent } from '../reset/reset-password.component';
import { AdsComponent } from './ads/ads.component';
import { LoginComponent } from './login.component';
const routes: Routes = [
  { path: 'a/:id', component: LoginComponent },
  //   { path: 'reset-password', component: LoginComponent },
  { path: '', component: LoginComponent },
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    ActivationComponent,
    ResetPasswordComponent,
    AdsComponent,
  ],
  exports: [],
  declarations: [LoginComponent],
  providers: [],
})
export class LoginModule {}
